const HIDDEN_PRODUCT_METADATA = new Set(['N/A', 'Default Title'])

/** Shopify placeholder values are implementation details and should never reach consumers. */
export function isDisplayableProductMetadata(
  value: string | null | undefined,
): value is string {
  return Boolean(value && !HIDDEN_PRODUCT_METADATA.has(value))
}
